<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? 'Add Cookie' : 'Edit Cookie'}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? 'Add Cookie' : 'Edit Cookie'}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Cookie</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'title[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'title[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'description[' + language.code + ']'" class="form-label">Description:</label>
                      <textarea rows="7" :id="'description[' + language.code + ']'" class="form-control" :name="'description_l[' + language.code + ']'" v-model="formData.description_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="description"></textarea>
                    </ValidationProvider>
                  </b-tab>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="code" class="form-label">Key:</label>
                    <input id="code" class="form-control" name="key" v-model="formData.key" placeholder="key" :class="classes" type="text">
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CurrencyAdd',
  data () {
    return {
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      formData: {
        title_l: {},
        description_l: {},
        key: ''
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      cookie: state => state.cookie.cookie
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.cookie
      })
    }
  },
  methods: {
    ...mapActions({
      create: 'cookie/create',
      update: 'cookie/update',
      getData: 'cookie/getData'
    }),
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true

          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/cookie')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/cookie')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
